import { NAV } from "../Navbar/navbarTheme";

export const AUTH_PRIMARY = NAV.navy;
export const AUTH_ACCENT = "#e31837";

export const AUTH_PAGE_BG = "#fff";

export const authPageSx = {
  minHeight: "calc(100vh - 200px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 2, sm: 3 },
  py: { xs: 3, md: 5 },
  pt: { xs: "clamp(88px, 12vh, 120px)", md: "clamp(100px, 14vh, 140px)" },
  background: AUTH_PAGE_BG,
};

export const authAccountPageSx = {
  px: { xs: 2, sm: 3 },
  py: { xs: 3, md: 5 },
  pt: { xs: "clamp(104px, 14vh, 150px)", md: "clamp(110px, 14vh, 150px)" },
  pb: { xs: 4, md: 6 },
  maxWidth: 680,
  mx: "auto",
  minHeight: "70vh",
  background: AUTH_PAGE_BG,
};

export const authCardSx = {
  width: "100%",
  maxWidth: 480,
  borderRadius: 3,
  border: `1px solid ${NAV.line}`,
  bgcolor: NAV.surface,
  boxShadow: "0 18px 48px rgba(15, 40, 71, 0.12)",
  overflow: "hidden",
};

export const authCardWideSx = {
  ...authCardSx,
  maxWidth: 560,
};

export const authCardHeaderSx = {
  px: { xs: 2.5, sm: 3 },
  py: { xs: 2.25, sm: 2.75 },
  background: `linear-gradient(135deg, ${AUTH_PRIMARY} 0%, #163a5e 55%, #1a4570 100%)`,
  color: "#fff",
  boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.12)",
};

export const authCardHeaderIconSx = {
  width: { xs: 48, sm: 54 },
  height: { xs: 48, sm: 54 },
  borderRadius: 2.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "rgba(255,255,255,0.14)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25)",
  flexShrink: 0,
};

export const authCardBodySx = {
  p: { xs: 2.5, sm: 3.5 },
};

export const authHeroSx = {
  mb: 3,
  p: { xs: 2.5, md: 3 },
  borderRadius: 3,
  overflow: "hidden",
  background: `linear-gradient(135deg, ${AUTH_PRIMARY} 0%, #163a5e 55%, #1a4570 100%)`,
  boxShadow: "0 18px 48px rgba(15, 40, 71, 0.18)",
  color: "#fff",
};

export const authFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    bgcolor: NAV.surfaceSubtle,
    fontSize: "0.9375rem",
    "& fieldset": {
      borderColor: NAV.line,
    },
    "&:hover fieldset": {
      borderColor: "#c5d0dc",
    },
    "&.Mui-focused fieldset": {
      borderColor: AUTH_PRIMARY,
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: AUTH_PRIMARY,
  },
};

export const authSubmitButtonSx = {
  mt: 1,
  py: 1.35,
  textTransform: "none",
  fontWeight: 800,
  fontSize: "1rem",
  borderRadius: 2,
  bgcolor: AUTH_ACCENT,
  boxShadow: "0 10px 28px rgba(227, 24, 55, 0.28)",
  "&:hover": {
    bgcolor: "#c8102e",
    boxShadow: "0 12px 32px rgba(227, 24, 55, 0.34)",
  },
};

export const authSecondaryButtonSx = {
  mt: 1.5,
  py: 1.1,
  textTransform: "none",
  fontWeight: 700,
  borderRadius: 2,
  color: AUTH_PRIMARY,
  borderColor: AUTH_PRIMARY,
  "&:hover": {
    borderColor: AUTH_PRIMARY,
    bgcolor: NAV.navyMuted,
  },
};

export const authFooterActionsSx = {
  mt: 3,
  pt: 2.5,
  borderTop: `1px solid ${NAV.line}`,
};

export const authFooterButtonSx = {
  py: 1.1,
  textTransform: "none",
  fontWeight: 700,
  borderRadius: 2,
  flex: 1,
};

export const authFooterSecondaryButtonSx = {
  ...authFooterButtonSx,
  color: AUTH_PRIMARY,
  borderColor: AUTH_PRIMARY,
  "&:hover": {
    borderColor: AUTH_PRIMARY,
    bgcolor: NAV.navyMuted,
  },
};

export const authLogoutButtonSx = {
  ...authFooterButtonSx,
  color: AUTH_ACCENT,
  borderColor: "rgba(227, 24, 55, 0.4)",
  "&:hover": {
    borderColor: AUTH_ACCENT,
    bgcolor: "rgba(227, 24, 55, 0.06)",
  },
};

export const authLinkSx = {
  color: AUTH_PRIMARY,
  fontWeight: 600,
  textDecoration: "none",
  "&:hover": { textDecoration: "underline" },
};

export const authAlertSx = {
  mb: 2.5,
  borderRadius: 2,
};

export const authFooterTextSx = {
  mt: 3,
  textAlign: "center",
  fontSize: "0.9375rem",
  color: NAV.inkMuted,
};
